import { useCallback, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Image } from "primereact/image";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BreadCrumbCustom from "../bread-crumb/bread-crumb";
import { BreadcrumbItem } from "../../interfaces/common/common";
import RouteConstant from "../../constants/route.constants";
import { Card } from "primereact/card";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import GetAddressByLocation from "./location-search/get-location";
import {AdminUserAddress1,UserEditAddress1,} from "../../models/user-address-model";
import { CountryModel } from "../../models/country-model";
import { StateModel } from "../../models/state-model";
import { CityModel } from "../../models/city-model";
import RoleService from "../../services/role/role-service";
import AppLoading from '../app-loading/app-loading';
import { Toast, ToastMessage } from "primereact/toast";
import { user } from "../../demo/user/user";
import { Message } from "primereact/message";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
 
const AddAddress = (props: any) => {
  const { id } = useParams();
  const isEdit: boolean = !!id && id !== "0";
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [countries, setCountries] = useState<CountryModel[]>([]);
  const [cities, setCities] = useState<StateModel[]>([]);
  const [states, setStates] = useState<CityModel[]>([]);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [latLngSelected, setLatLngSelected] = useState<string | null>(null);
  const userId = props.userId;
  const isAdmin = RoleService.isAdmin();
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);
  const [isPincodeSearched, setIsPincodeSearched] = useState(false);
  const [oldPincode,setOldPincode] = useState<any>();
  const [originalPincode, setOriginalPincode] = useState<string>("");
  const [originalArea, setOriginalArea] = useState<string>("");
  const adminUsersId = useAppSelector(
    (state) => state.adminUser.selectedAdminUserId
  );
  var navigate = useNavigate();
  const { t } = useTranslation();
 
  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage["severity"]
  ) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };
 
  const formik: any = useFormik({
    initialValues: {
      id: "",
      name: "",
      addressLine1: "",
      addressLine2: "",
      landMark: "",
      pincode: "",
      areaId: "",
      sameAddressLine1: false,
      subDistrictId : 0,
      districtId : 0,
      stateId : 0,
      countryId:0,
      gpsLocation: ""
    },
 
    validate: (data: any) => {
      let errors: any = {};
      if (!data.addressLine1) {
        errors.addressLine1 = t("Address line1 is required");
      }
      if (!data.pincode) {
       
      } else if (isNaN(Number(data.pincode))) {
        errors.pincode = t("Pincode must be numeric");
      } else if (data.pincode.length < 3 || data.pincode.length > 6) {
        errors.pincode = t("Pincode must be 4 to 6 digits");
      }
      return errors;
    },
 
    onSubmit: async (data: any) => {
      const pincode = String(data.pincode || "").trim();
     
      // Validate pincode format
      if (!pincode) {
        showMessage("Error", "Please Enter Pincode", "error");
        return;
      }
 
      if (isNaN(Number(pincode))) {
        showMessage("Error", "Please enter a valid numeric pincode", "error");
        return;
      }
 
      if (pincode.length < 4 || pincode.length > 6) {
        showMessage("Info", "Pincode must be 4-6 digits", "info");
        return;
      }
 
      // Check if pincode was changed in edit mode
      if (isEdit && pincode !== originalPincode && !isPincodeSearched) {
        showMessage("Info", "Please verify the new pincode by clicking the search icon ", "info");
        return;
      }
 
      // Check if pincode was searched (for both new and edit cases)
      if (!isPincodeSearched) {
        showMessage("Info", "Please verify pincode by clicking the search icon ", "info");
        return;
      }
 
      // Check if area needs to be selected (when multiple areas exist)
      if (areas.length > 1 && !data.areaId) {
        showMessage("Error", "Please select an area from the dropdown before updating", "error");
        return;
      }
 
      // If pincode was changed, ensure area is selected (even if only one area exists)
      if (isEdit && pincode !== originalPincode && !data.areaId) {
        showMessage("Info", "Please select an area from the dropdown ", "info");
        return;
      }
 
      let addressData: UserEditAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: pincode,
        gpsLocation: latLngSelected,
        userID: userId,
        areaId: data.areaId !== "" && areas.length !== 1 ? data.areaId : areas[0]?.areaId
      };
      let adminAddressData: AdminUserAddress1 = {
        userAddressID: data.id,
        address1: data.addressLine1,
        address2: data.addressLine2,
        landmark: data.landMark,
        zipcode: pincode,
        gpsLocation: latLngSelected,
        userID: adminUsersId,
        areaId: data.areaId !== "" && areas.length !== 1 ? data.areaId : areas[0]?.areaId,
      };
 
      setLoading(true);
      try {
        var response;
        if (!isEdit)
           {
        // const response = await UserAddressService.apiuserAddress1(addressData);
          if (isAdmin)
         {
         response=await UserAddressService.apiuserAddress1(adminAddressData);
         } 
        else
         {
         response=await UserAddressService.apiuserAddress1(addressData);
         }
        if (response?.isSuccess) {
          showMessage("Success", "Address added successfully", "success");
          navigate(RouteConstant.userAddresses);
        } else {
          if (response?.message?.includes("Duplicate User address")) {
            showMessage("Info", "Address already exists", "info");
          } else {
            showMessage("Error", response?.message || "Failed to save address", "error");
          }
        }
        } else {
          if (isAdmin && !isEdit) {
            const userAddress = await UserAddressService.addAdminAddress2(adminAddressData);
            if (userAddress.isSuccess) {
              showMessage("Success", "Address added successfully", "success");
              navigate(RouteConstant.userAddresses);
            }
          } else {
            //const response = await UserAddressService.updateUserAddressOnEdit(addressData);
            
         if (isAdmin && adminUsersId) {
          response=await UserAddressService.updateUserAddressOnEdit(adminAddressData);
           }
         else {
         response=await UserAddressService.updateUserAddressOnEdit(addressData);
               }
            if (response.isSuccess) {
              showMessage("Success", "Address updated successfully", "success");
              navigate(RouteConstant.userAddresses);
            }
            else {
            showMessage("Warning", response.message || "Failed to update address.", "warn");
            }
          }
        }
      } catch (error) {
        showMessage("Error", "Failed to save address", "error");
      } finally {
        setLoading(false);
      }
    },
  });
 
  const handlePincodeChange = (e: { target: { value: any; }; }) => {
    var newPincode = e.target.value;
    formik.handleChange(e);
 
    if (isEdit || newPincode !== formik.values.pincode) {
      setIsPincodeSearched(false);
      setAreas([]);
      setSubdistricts([]);
      setDistricts([]);
      setPinState([]);
      setPinCountry([]);
      setenabelDropdown(true);
      setOldPincode(newPincode);
      formik.setFieldValue("areaId", ""); // Reset area selection
    }
      if (newPincode.length === 6 && !isNaN(Number(newPincode))) {
        handleLocationFetch(parseInt(newPincode));
      } else if (newPincode.length > 6) {
        showMessage("Error", "Pincode must be 6 digits or less", "error");
    }
  };
 
  const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
        setLatLngSelected(location);
      } catch {}
    }
  };
 
  async function fetchData(addressId: number) {
    var userAddress: any = await UserAddressService.getUserAddress(addressId);
    if(userAddress[0].areaId != null){
      if (userAddress) {
        formik.setValues({
          id: userAddress[0].userAddressID,
          name: userAddress[0].userName,
          addressLine1: userAddress[0].address1,
          addressLine2: userAddress[0].address2,
          landMark: userAddress[0].landmark,
          country: userAddress[0].countryName,
          state: userAddress[0].stateName,
          areaId: userAddress[0].areaId,
          area: userAddress[0].areaName,
          district: userAddress[0].DisticName,
          subDistrict: userAddress[0].subDisticName,
          pincode: userAddress[0].pincode,
          sameAddressLine1: userAddress[0].sameAddressLine1,
          gpsLocation: userAddress[0].gpsLocation,
        });
        setOriginalPincode(userAddress[0].pincode);
        setOriginalArea(userAddress[0].areaId);
        formik.setFieldValue("area", userAddress[0].areaName || "");
        formik.setFieldValue("areaId", userAddress[0].areaId || "");
        setAreas([{ areaId : userAddress[0].areaId,subDistrictId : userAddress[0].subDisticId,areaName : userAddress[0].areaName}]);
 
        setSubdistricts([{districtId : userAddress[0].disticId,subDistrictId : userAddress[0].subDisticId,subDistrictName : userAddress[0].subDisticName}]);
        setDistricts([{districtId : userAddress[0].disticId,districtName : userAddress[0].disticName}]);
        setPinState([{stateId : userAddress[0].stateId,districtId : userAddress[0].disticId,stateName : userAddress[0].stateName}]);
        setPinCountry([{countryId : userAddress[0].countryId,countryName : userAddress[0].countryName}]);
        formik.setFieldValue("areaId", userAddress[0].areaId || "");
        formik.setFieldValue("area", userAddress[0].areaName || "");
        setenabelDropdown(false);
        setIsPincodeSearched(true);
      } else {
        if (!RoleService.isAdmin) {
          navigate(RouteConstant.userAddresses);
        }
      }
    }
    else{
      if (userAddress) {
        UserAddressService.getCities(userAddress[0].OldStateId).then((r) => setCities(r));
        updateLatitudeAndLongitude(userAddress.gpsLocation);
        formik.setValues({
          id: userAddress[0].userAddressID,
          name: userAddress[0].userName,
          addressLine1: userAddress[0].address1,
          addressLine2: userAddress[0].address2,
          landMark: userAddress[0].landmark,
          country: userAddress[0].OldCountryId,
          state: userAddress[0].OldStateId,
          city: userAddress[0].OldCityId,
          pincode: userAddress[0].zipcode,
          areaId: formik.values.areaId,
          sameAddressLine1: userAddress.sameAddressLine1,
          gpsLocation: userAddress[0].gpsLocation,
        });
        setIsPincodeSearched(true);
      } else {
        if (!RoleService.isAdmin) {
          navigate(RouteConstant.userAddresses);
        }
      }
    }
  }
 
  useEffect(() => {
    UserAddressService.getCountries().then((r) => setCountries(r));
    if (isEdit) {
      let addressId: number = id != null ? parseInt(id) : 0;
      fetchData(addressId);
    }
  }, []);
 
  const isFormFieldInvalid = (name: any) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name: any) => {
    return isFormFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
 
  const updateGpsLocation = useCallback(async (latLng: any) => {
    setIsLocationMapVisible(false);
    setLatLngSelected(latLng);
    updateLatitudeAndLongitude(latLng);
    formik.setFieldValue("gpsLocation", latLng);
    if (isEdit && latLng && id != null) {
      UserAddressService.updateGPSLocation(parseInt(id), latLng);
    }
  }, []);
 
  const breadCrumbItems: BreadcrumbItem = {
    items: [{ label: t("editaddress_breadcrumb_editaddress") }],
    home: { label: t("common_breadcrumb_home") },
    backgroundImage: process.env.PUBLIC_URL + "/assests/images/image-1.jpeg",
    title: t("useraddress_breadcrumb_label"),
  };
 
  interface LocationDetails {
    areaId: string;
    areaName?: string;
    subDistrictsName?: string;
    districtName?: string;
    stateName?: string;
    countryName?: string;
  }
 
  const [locationDetails, setLocationDetails] = useState<LocationDetails[] | null>(null);
  const [areas, setAreas] = useState<{areaId:number;subDistrictId:number;areaName:string}[]>([]);
  const [subdistricts, setSubdistricts] = useState<{districtId:number,subDistrictId :number; subDistrictName : string}[]>([]);
  const [filterSubdistricts, setFilterSubdistricts] = useState<{districtId:number,subDistrictId :number; subDistrictName : string}[]>([]);
  const [districts, setDistricts] = useState<{districtId : number ; districtName : string}[]>([]);
  const [pinstate, setPinState] = useState<{stateId : number; stateName : string; districtId : number ;}[]>([]);
  const [pincountry, setPinCountry] = useState<{countryId : number ; countryName : string}[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [enabelDropdown,setenabelDropdown] = useState<boolean>(true);
  const [filterDistricts, setFilterDistricts] = useState<{districtId : number ; districtName : string}[]>([]);
  const[filterStates,setfilterStates] = useState<{stateId : number; districtId : number ; stateName : string}[]>([]);
 
  const handleLocationFetch = async (pincode: number) => {
    try {
      setLoading(true);
      setSubdistricts([]);
      setFilterSubdistricts([]);
      var responsedData = await UserAddressService.getAddress(pincode);
     
        if(responsedData != null && responsedData.isSuccess) {
          if (!responsedData.areas || responsedData.areas.length === 0) {
            showMessage("Error", "Area is not found please contact admin.", "error");
            setIsPincodeSearched(false);
            setenabelDropdown(true);
            setLoading(false);
            return;
          }
        setAreas(responsedData.areas);
        setSubdistricts(responsedData.subDistricts);
        setFilterSubdistricts(responsedData.subDistricts);
        setDistricts(responsedData.districts);
        setFilterDistricts(responsedData.districts);
        setPinState(responsedData.states);
        setPinCountry(responsedData.countries);
        setfilterStates(responsedData.states);
        setenabelDropdown(false);
        setIsPincodeSearched(true);
       
        // Reset area selection when pincode changes
        formik.setFieldValue("areaId", "");
       
        if (responsedData.areas.length === 1) {
          formik.setFieldValue("areaId", responsedData.areas[0].areaId);
   
        }
       
        setLoading(false);
      }
      else {
        setenabelDropdown(true);
        setLoading(false);
        showMessage("Error" ,responsedData?.message || "Area is not found please contact admin.", "error");
      }
    } catch (error) {
      formik.setFieldError('pincode', t("editaddress_pin_code"));
      showMessage("Error", "Failed to fetch pincode details", "error");
      setLoading(false);
      return false;
    }
  };
 
  const handelAreaChange = async (Id:any, value : any) => {
    formik.setFieldValue(Id,value);
    var SubdistcId = areas.filter(x => x.areaId === value)[0].subDistrictId;
    var filterdata = filterSubdistricts.filter(x  => x.subDistrictId === SubdistcId);
    var filterdat = filterDistricts.filter(x => x.districtId === filterdata[0].districtId);
    var filterstate = filterStates.filter(x => x.districtId === filterdata[0].districtId)
    setDistricts(filterdat);
    setPinState(filterstate);
    setSubdistricts(filterdata);
    formik.setFieldValue("subDistrictId", filterdata[0].subDistrictId);
    formik.setFieldValue("districtId", filterdat[0].districtId);
    formik.setFieldValue("stateId", pinstate[0].stateId);
    formik.setFieldValue("countryId", pincountry[0].countryId);
  }
 
  const handelsubdistc = async (Id:any) => {
    formik.setFieldValue("subDistrictId", Id)
  }
 
  return (
    <>
      <Toast ref={toast} position="top-right" />
      {!isAdmin && (
        <BreadCrumbCustom
          items={breadCrumbItems.items}
          home={breadCrumbItems.home}
          backgroundImage={breadCrumbItems.backgroundImage}
          title={breadCrumbItems.title}
        ></BreadCrumbCustom>
      )}
      <div
        className={
          !isAdmin
            ? "container-fluid Address-form-container layout-content mt-3 mb-3"
            : "container-fluid Address-form-container"
        }
      >
        <div className="col-12">
          {!isAdmin ? (
            <h5 className="mobile-txt-fnt mb-0">
              <Link to={RouteConstant.userAddresses} className="history-title">
                <i className="pi pi-arrow-left"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
              {isEdit
                ? t("editaddress_edit_address")
                : t("editaddress_add_address")}
            </h5>
          ) : (
            <h5 className="border-round order-top-color p-2">
              {t("editaddress_add_address")}
            </h5>
          )}
        </div>
        <div className="flex flex-column md:flex-row">
          <div className={`${isAdmin ? "col-12" : "col-9"}`}>
            <Card className="user-address-card border-1 surface-border m-0">
              <form onSubmit={formik.handleSubmit} className="flex flex-column">
                <div className="p-fluid formgrid grid">
                  <div className="field col-12 ">
                    <label htmlFor="addressLine1" className="label-semi-bold">
                      {t("editaddress_address_line_1")}
                      <span className="required">*</span>
                    </label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea
                        placeholder={t(
                          "editaddress_please_enter_address_line1"
                        )}
                        rows={2}
                        name="addressLine1"
                        id="addressLine1"
                        value={formik.values.addressLine1}
                        onChange={formik.handleChange}
                        className={classNames()}
                      />
                    </span>
                    {getFormErrorMessage("addressLine1")}
                  </div>
                  <div className="field col-12 ">
                    <label htmlFor="addressLine2" className="label-semi-bold">
                      {t("editaddress_address_line_2")}
                    </label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea
                        placeholder={t(
                          "editaddress_please_enter_address_line2"
                        )}
                        rows={2}
                        name="addressLine2"
                        id="addressLine2"
                        value={formik.values.addressLine2}
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": formik.errors.addressLine2,
                        })}
                      />
                    </span>
                    {getFormErrorMessage("addressLine2")}
                  </div>
                  <div className="field col-12 ">
                    <label htmlFor="landMark" className="label-semi-bold">
                      {t("editaddress_land_mark")}
                    </label>
                    <span className="p-input-icon-left">
                      <i className="pi pi-home text-area-icon" />
                      <InputTextarea
                        placeholder={t("editaddress_please_enter_land_mark")}
                        value={formik.values.landMark || ""}
                        rows={2}
                        name="landMark"
                        id="landMark"
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": formik.errors.landMark,
                        })}
                      />
                    </span>
                    {getFormErrorMessage("editaddress_land_mark")}
                  </div>
                  <div className="col-6">
                  </div>
                  <div className="field col-12 sm:col-6 lg:col-12 mr-0 sm:mr-3">
                    <div className="field col-6 md:col-6 sm:col-6 md:col-4 lg:col-3 mr-0 sm:mr-3 ">
                      <label htmlFor="pincode">
                        {t("editaddress_pincode")}
                        <span className="required">*</span>
                      </label>
                      <div className="p-inputgroup">
                        <span className="p-input-icon-left">
                          <i className="pi pi-hashtag" />
                          <InputText
                            keyfilter="int"
                            name="pincode"
                            id="pincode"
                            placeholder={t("editaddress_please_enter_pincode")}
                            value={formik.values.pincode}
                            onChange={handlePincodeChange}
                            maxLength={6}
                            className={classNames({
                              "p-invalid": formik.errors.pincode,
                            })}
                            style={{ width: "100%" }}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            pattern="\d*"
                          />
                        </span>
                        <Button
                          icon="pi pi-search"
                          severity="success"
                          aria-label="Search"
                          style={{width:'50px'}}
                          onClick={(e) => {
                            e.preventDefault();
                            const pincodeValue = formik.values.pincode.trim();
                           
                            if (!pincodeValue || isNaN(Number(pincodeValue))) {
                              showMessage("Error", "Invalid pincode format", "error");
                              return;
                            }
                           
                            if (pincodeValue.length < 4 || pincodeValue.length > 6) {
                              showMessage("Error", "Pincode must be 4-6 digits", "error");
                              return;
                            }
 
                            handleLocationFetch(parseInt(pincodeValue));
                          }}
                        />
                      </div>
                      {getFormErrorMessage("pincode")}
                      {formik.errors.pincode && (
                        <small className="p-error">{formik.errors.pincode}</small>
                      )}
                    </div>
                  </div>
                  <div className="form-row" hidden={enabelDropdown}>
                    {areas.length > 1 && !formik.values.areaId && (
                      <div className="col-12 mb-3">
                      </div>
                    )}
                    <div className="grid col-12 mr-8">
                    <div className="field col-12 sm:col-6 md:col-4 lg:col-3 ">
 
 
                     <label htmlFor="area" className="label-semi-bold">
                     Area
                     </label>
                    <Dropdown
                     value={formik.values.areaId}
                      options={areas.map((area: any) => ({
                     label: area.areaName,
                        value: area.areaId,
                     }))}
                     onChange={(e) => handelAreaChange("areaId", e.value)}
                     placeholder={areas.length > 1 ? "Select Area*" : "Area"}
                     disabled={areas.length === 1}
                     className={classNames({
                      "p-invalid": areas.length > 1 && !formik.values.areaId,
                      })}
                     />
                     {areas.length > 1 && !formik.values.areaId && (
                     <small className="p-error">Please select an area</small>
                          )}
                      </div>
                      <div className="col-12 sm:col-6 md:col-4 lg:col-2 mr-0 sm:mr-3">
                    <label htmlFor="subdistrict" className="label-semi-bold">
                       Subdistrict
                      </label>
                     <InputText
                       value={subdistricts.length === 1 ? subdistricts[0].subDistrictName : formik.values.subdistrict}
                       onChange={(e) => handelsubdistc(e.target.value)}
                      disabled={true}
                      />
                      </div>
 
                    <div className="col-12 sm:col-6 md:col-4 lg:col-2 mr-0 sm:mr-3">
                    <label htmlFor="district" className="label-semi-bold">
                    District
                    </label>
                    <InputText
                      value={districts.length === 1 ? districts[0].districtName : formik.values.district}
                       onChange={(e) => formik.setFieldValue("districtId", e.target.value)}
                     disabled={true}
                      />
                      </div>
 
                    <div className="col-12 sm:col-6 md:col-4 lg:col-2 mr-0 sm:mr-3">
                      <label htmlFor="state1" className="label-semi-bold">
                        State
                      </label>
                      <InputText
                        value={pinstate.length === 1 ? pinstate[0].stateName : formik.values.selectedState}
                        onChange={(e) => formik.setFieldValue("stateId", e.target.value)}
                        disabled={true}
                      />
                    </div>
 
                   <div className="col-12 sm:col-6 md:col-4 lg:col-2 mr-0 sm:mr-3">
                    <label htmlFor="country" className="label-semi-bold">
                   Country
                    </label>
                    <InputText
                    value={pincountry.length === 1 ? pincountry[0].countryName : selectedCountry}
                    onChange={(e) => formik.setFieldValue("countryId", e.target.value)}
                    disabled={true}
                    />
                    </div>
                    </div>
                  </div>
                </div>
                <div className="field col-12 md:col-6">
                  <label></label>
                  <span className="p-inputgroup get-location-btn">
                    <Button
                      type="button"
                      severity="secondary"
                      label={formik.values.gpsLocation ?  "Edit Location" : "Add Location"}
                      icon="pi pi-map-marker"
                      value={formik.values.secondary}
                      outlined
                      onClick={() => setIsLocationMapVisible(true)}
                    ></Button>
                  </span>
                </div>
                <div className="col-12 flex justify-content-between">
                  {!isAdmin ? (
                    <div>
                      <Button
                        type="submit"
                        className="bg-primary"
                        label={
                          isEdit
                            ? t("common_update_button")
                            : t("common_add_button")
                        }
                        severity="success"
                        disabled={areas.length > 1 && !formik.values.areaId}
                      />
                    </div>
                  ) : (
                    <Button
                      type="submit"
                      className="bg-primary w-11rem"
                      label={isEdit ? t("common_update_button") : t("common_add_button")}
                      severity="success"
                      disabled={areas.length > 1 && !formik.values.areaId}
                    />
                  )}
                </div>
              </form>
            </Card>
          </div>
          {!isAdmin && (
            <div className="col-3 flex bg-light-green justify-content-center ">
              <Image
                width="150"
                src={process.env.PUBLIC_URL + "/assests/images/homelogo.png"}
                alt="Image"
                className="align-self-center align-items-center"
              />
            </div>
          )}
        </div>
      </div>
      <Dialog
        header="Search your location"
        className="location-dialog"
        visible={isLocationMapVisible}
        onHide={() => setIsLocationMapVisible(false)}
        footer={""}
        style={{ width: "50%" }}
      >
        <GetAddressByLocation
          getLatitudeLongitude={updateGpsLocation}
          lat={latitude}
          lng={longitude}
        ></GetAddressByLocation>
      </Dialog>
      {loading && <AppLoading />}
    </>
  );
};
 
export default AddAddress;
 
 